import { ChangeEventHandler, useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import Option from "../components/Option";
import { getOnlyUnique, SalesPerformanceList, SalesPerformanceType } from "../components/commonWidget";
import chartIcon from "../components/custom/assets/images/dashboard/chart_icon.svg";
import { MultiSelect } from "../components/custom/components";
import FormInput2 from "../components/custom/components/FormInput2";
import {
  Tbody,
  Thead,
} from "../components/custom/components/TradeCategoryPerformanceTable";
import TransactionTable from "../components/custom/components/TransactionTable";
import HorizontalBarChart from "../components/custom/components/charts/apex/HorizontalBarChart";
import { COLORS } from "../components/custom/constants";
import UserLayout from "../components/custom/layouts/UserLayout";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";
import { defaultLocation, defaultPortfolio, defaultTradeCategory, defaultTradeSubCategory, DropDownOption1, PAGE_SIZE } from "../config";
import api, { APIResponse, getAxiosRequestConfig } from "../config/api";
import {
  CSVdownload,
  YearOptions,
  handleDownloadPDF,
} from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { BrandType } from "../redux/actions/brandActions";
import { BrandCompanyType } from "../redux/actions/brandCompanyActions";
import { PortfolioType } from "../redux/actions/portfolioActions";
import {
  OptionsTypes,
  addToSelectedOption,
} from "../redux/actions/selectedOptionsActions";
import { SiteType } from "../redux/actions/siteActions";
import { TradeCategoryType } from "../redux/actions/tradeCategoryActions";
import { TradeSubCategoryType } from "../redux/actions/tradeSubCategoryActions";
import { StoreState } from "../redux/store";
import {
  BuildingDataType,
  BuildingType,
  FloorDataType,
  FloorType,
} from "./SalesOverAllSalesReport";
import { CatSubCatCompanyWithBrandRelationDataType } from "./TransactionBillWiseReport";
import Loader from "../components/custom/components/Loader";
import TransactionTable1 from "../components/custom/components/TransactionTable1";
import Modal from "../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowMaximize } from "@fortawesome/free-solid-svg-icons";
import { areaType } from "../redux/actions/areaActions";
import { SalesBottom10Brands, SalesBottom10BrandsMonthwise, SalesTop10Brands, SalesTop10BrandsMonthwise } from "../components/salesReports/salesRanking";
import { UserLog } from "../config/common";
import { useLocation } from "react-router-dom";
import SingleSelect from "../components/custom/components/SingleSelect";
import { outletType } from "../redux/actions/outletActions";
import SingleSelect1 from "../components/custom/components/SingleSelect1";

export interface DropDownOption {
  value: number;
  label: string;
  imgUrl: string;
}

export interface SalesRankingRecord {
  brand: number;
  sales: string;
  transyear?: number;
  month?:number
}

export interface SalesRankingReportType {
  topBrands: {
    portfolio: number;
    record: SalesRankingRecord[];
    count?: number;
  }[];
  bottomBrands: {
    portfolio: number;
    record: SalesRankingRecord[];
    count?: number;
  }[];
}

const SalesRankingReport = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const pageName = useLocation();
  const authUser = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  );
  const authUserToken = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  )?.["auth-token"]!;
  const config = getAxiosRequestConfig(authUserToken);

  const authUserSiteId = authUser?.siteId;

  const portfolioOption = useSelector<StoreState, PortfolioType[]>(
    (state) => state?.portfolio
  );
  const siteOption = useSelector<StoreState, SiteType[]>((state) => state?.site);
  const brandOption = useSelector<StoreState, BrandType[]>(
    (state) => state?.brand
  );
  const brandCompanyOption = useSelector<StoreState, BrandCompanyType[]>(
    (state) => state?.brandCompany
  );
  const selectedOption = useSelector<StoreState, OptionsTypes>(
    (state) => state?.selectedOption
  );

  const filteredBrandCompany = brandCompanyOption?.filter(
    (a) => a?.retailid !== null
  );

  const filteredBrand = brandOption?.filter((a) => {
    return brandCompanyOption?.some(
      (b) => b?.id?.toString() === a?.companyid?.toString() && b?.retailid !== null
    );
  });

  const port =
    authUser?.portfolioId !== undefined && authUser?.portfolioId !== null
      ? authUser?.portfolioId?.split(",")
      : [];

  let portfolioData = port
    ?.map((pe) => {
      return portfolioOption?.filter(
        (f) => f?.id?.toString() === pe?.toString()
      );
    })
    ?.flat(1);

  const pname = portfolioData[0]?.name;

  const st =
    authUser?.siteId !== undefined && authUser?.siteId !== null
      ? authUser?.siteId?.split(",")
      : [];

  let siteData = st
    ?.map((pe) => {
      return siteOption?.filter((f) => f?.id?.toString() === pe?.toString());
    })
    ?.flat(1);

  const categoryOption = useSelector<StoreState, TradeCategoryType[]>(
    (state) => state?.tradeCategory
  );
  const subCategoryOption = useSelector<StoreState, TradeSubCategoryType[]>(
    (state) => state?.tradeSubCategory
  );
  const localityOption = useSelector<StoreState, areaType[]>(
    (state) => state?.locality
  );
  const outletList = useSelector<StoreState, outletType[]>(
    (state) => state?.outlet
  );

  const month = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  const [buildingData, setBuildingData] = useState<BuildingDataType[]>([]);
  const [floorData, setFloorData] = useState<FloorDataType[]>([]);
  const [
    catSubCatCompanyWithBrandRelationData,
    setCatSubCatCompanyWithBrandRelationData,
  ] = useState<CatSubCatCompanyWithBrandRelationDataType[]>([]);

  const [year, setYear] = useState<Date>(new Date());

  const [valueIn, setValueIn] = useState<string>("");

  const [portfolios, setPortfolios] = useState<string>("");
  const [sites, setSites] = useState<string>("");
  const [brands, setBrands] = useState<string>("");
  const [companies, setCompanies] = useState<string>("");

  // const [locations, setLocations] = useState<DropDownOption[]>([]);
  const [location, setLocation] = useState<string>("");
  const [categories, setCategories] = useState<string>("");
  const [subCategories, setSubCategories] = useState<string>("");
  const [disableLocality, setDisableLocality] = useState<boolean>(false);

  //loader
  const [fileLoader, setFileLoader] = useState<boolean>(false);
  const [loader, setloader] = useState<boolean>(false);

  const [salesRankingData, setSalesRankingData] = useState<
    SalesRankingReportType[]
  >([]);

  const [salesRankingMonthlyData, setSalesRankingMonthlyData] = useState<
  SalesRankingReportType[]
>([]);




  const limit = PAGE_SIZE;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(50);

  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [selectedRows1, setSelectedRows1] = useState<string[]>([]);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [reportName,setReportName] = useState<string>('Yearly')
  const [yearAndMonth, setYearAndMonth] = useState<Date>(new Date());

  const [portfoliosOption, setPortfoliosOption] = useState<DropDownOption1>(defaultPortfolio);
  const  [locationOption,setLocationOption] = useState<DropDownOption1>(defaultLocation)
  const [categoriesOption, setCategoriesOption] = useState<DropDownOption1>(defaultTradeCategory);
  const [subCategoriesOption, setSubcategoriesOption] = useState<DropDownOption1>(defaultTradeSubCategory);

  const [portfolioDrop, setPortfolioDrop] = useState<DropDownOption[]>([]);
  const [locationDrop, setLocationDrop] = useState<DropDownOption[]>([]);
  const [catDrop,setCatDrop] = useState<DropDownOption[]>([])
  const [subcatDrop,setSubcatDrop] = useState<DropDownOption[]>([])
  
  const [selection, setSelection] = useState<SalesPerformanceType>(
    SalesPerformanceList?.YEARLY
  );
  const showExpandModalHandler = () => {
    setShowModal(true)
  };

  const handleSelectedRowsChange = (selectedRows: string[]) => {
    setSelectedRows(selectedRows);
  };

  const handleSelectedRowsChange1 = (selectedRows1: string[]) => {
    setSelectedRows1(selectedRows1);
  };

  const monthlyHandler = () => {
    setSelection(SalesPerformanceList?.MONTHLY);
    setReportName('Monthly')
  };
  const yearlyHandler = () => {
    setSelection(SalesPerformanceList?.YEARLY);
    setReportName('Yearly')
  };


  const subCategoryFilteredByCategory = useMemo<TradeSubCategoryType[]>(() => {
    if (categories !== "") {
      return subCategoryOption?.filter((sc) => {
        return sc?.catid?.toString() === categories?.toString();
      });
    } else return subCategoryOption;
  }, [categories, subCategoryOption]);

  // const locality = useMemo<string[]>(() => {
  //   return locations?.map((p) => {
  //     return p?.label;
  //   });
  // }, [locations]);

  const handlePortfolioDrop = (selected: any) => {
    if(fileLoader===false){
    if(selected.length>0){
      const selectedPortfolio = selected as DropDownOption[];
      if(selectedPortfolio[0].value!==null&&selectedPortfolio[0].value!==0){
        setPortfolioDrop(selectedPortfolio)
        setPortfolios(selectedPortfolio[0]?.value?.toString())
        const data = { ...selectedOption, portfolio: selectedPortfolio[0]?.value?.toString() };
        dispatch(addToSelectedOption(data));
        setOffset(0);
      }
    }
  }
  };

  const handleClearPortfolio = () =>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);

      if(fileLoader===false){
      setLocation("");
      setLocationDrop([]);
      const data = { ...selectedOption, portfolio: b[0]?.id?.toString(),location:''};
      dispatch(addToSelectedOption(data));
      setOffset(0);
    }
  }
  }

  const handleLocationDrop = (selected: any) => {
    if(fileLoader===false){
    if(selected.length>0){
      const selectedLocation = selected as DropDownOption[];
      if(selectedLocation[0].value!==null&&selectedLocation[0].value!==0){
        setLocationDrop(selectedLocation)
        setLocation(selectedLocation[0]?.label?.toString())
       const data = { ...selectedOption,location: selectedLocation[0]?.label?.toString()};
       dispatch(addToSelectedOption(data));
       setOffset(0);
      }
    }
  }
  };
  
  const handleClearLocation = () =>{
       if(fileLoader===true){
        setLocation(location ? location : '');
        const b = localityOption.filter((a)=>a?.area?.toString()===location?.toString())
        if (b?.length > 0 && b[0]?.id !== undefined) {
          const val: DropDownOption = {
            value: b[0]?.id, 
            label: b[0]?.area,
            imgUrl:'', 
          };
          setLocationDrop([val]);
       }
       else{
        setLocationDrop([])
     }
      }
     
       if(fileLoader===false){
         setLocationDrop([])
         setLocation('')
       const data = { ...selectedOption,location: ""};
        dispatch(addToSelectedOption(data));
        setOffset(0);
       }
  }

  const handleCatDrop = (selected: any) => {
    if(fileLoader===false){
    if(selected.length>0){
      const selectedCat = selected as DropDownOption[];
      if(selectedCat[0].value!==null&&selectedCat[0].value!==0){
        setCatDrop(selectedCat)
        setCategories(selectedCat[0]?.value?.toString())
        setSubcatDrop([])
        setSubCategories('')
        const data = {
          ...selectedOption,
          category: selectedCat[0]?.value?.toString(),
          subCategory: "",
          brand: "",
          brands:[]
        };
        dispatch(addToSelectedOption(data));
        setOffset(0);
      }
    }
  }
  };
  
  const handleClearCat = () =>{
    if(fileLoader===true){
      setCategories(categories ? categories : '');
      const b = categoryOption.filter((a)=>a?.id?.toString()===categories?.toString())
      if (b?.length > 0 && b[0]?.id !== undefined) {
        const val: DropDownOption = {
          value: b[0]?.id, 
          label: b[0]?.name,
          imgUrl:'', 
        };
        setCatDrop([val]);
     }
     else{
      setCatDrop([])
   }
    }
   
     if(fileLoader===false){
      setCatDrop([])
      setCategories('')
      setSubcatDrop([])
        setSubCategories('')
       const data = { ...selectedOption,
        category: '',
        subCategory: "",
        brand: "",brands:[]};
       dispatch(addToSelectedOption(data));
       setOffset(0);
     }
  }

  const handleSubcatDrop = (selected: any) => {
    if(fileLoader===false){
    if(selected.length>0){
      const selectedSubcat = selected as DropDownOption[];
      if(selectedSubcat[0].value!==null&&selectedSubcat[0].value!==0){
        setSubcatDrop(selectedSubcat)
        setSubCategories(selectedSubcat[0]?.value?.toString())
        setBrands('')
        const data = { ...selectedOption,
          subCategory: selectedSubcat[0]?.value?.toString(),
          brand: "",brands:[]};
         dispatch(addToSelectedOption(data));
         setOffset(0);
      }
    }
  }
  };
  
  const handleClearSubcat = () =>{
    if(fileLoader===true){
      setSubCategories(subCategories ? subCategories : '');
      const b = subCategoryOption.filter((a)=>a?.id?.toString()===subCategories?.toString())
      if (b?.length > 0 && b[0]?.id !== undefined) {
        const val: DropDownOption = {
          value: b[0]?.id, 
          label: b[0]?.name,
          imgUrl:'', 
        };
        setSubcatDrop([val]);
     }else{
      setSubcatDrop([])
   }
    }
   
     if(fileLoader===false){
      setSubcatDrop([])
        setSubCategories('')
        setBrands('')
       const data = { ...selectedOption,
        subCategory: "",
        brand: "",brands:[]};
       dispatch(addToSelectedOption(data));
       setOffset(0);
     }
  }



  const tHead = useMemo<Thead[]>(() => {
    var theadArray: {
      id: string;
      children: string;
      text: string;
    }[] = [
      { id: "Brand", children: "Brand", text: "Brand" },
      { id: "NetSales", children: "NetSales", text: "NetSales" },
    ];

    return theadArray;
  }, []);

  const tHead1 = useMemo<Thead[]>(() => {
    var theadArray: {
      id: string;
      children: string;
      text: string;
    }[] = [
      { id: "Brand", children: "Brand", text: "Brand" },
      { id: "NetSales", children: "NetSales", text: "NetSales" },
    ];

    return theadArray;
  }, []);

  const getDownloadData = (
    Data: {
      portfolio: number;
      record: SalesRankingRecord[];
      count?: number;
    }[]
  ) => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];

    const tbody = Data;

    Data?.forEach((y, i) => {
      const brandArray = y?.record?.map((r, j) => r?.brand)?.filter(getOnlyUnique);

      brandArray?.forEach((br, j) => {
        var tBody: Tbody[] = [];
        const brandIndex = filteredBrand?.findIndex(
          (c) => c?.id !== undefined && c?.id?.toString() === br?.toString()
        );
        const brandName = filteredBrand[brandIndex]?.name;
        const brandId = br;

        tBody?.push({
          id: "Brand" + brandId + j,
          theadId: "Brand",
          children: brandName,
          text: brandName,
        });
        y?.record
          ?.filter((r) => r?.brand?.toString() === brandId?.toString())
          ?.forEach((r, i) => {
            tBody?.push({
              id: r?.sales?.toString() + i,
              children: r?.sales,
              text: r?.sales,
              theadId: "NetSales",
            });
          });
        if (tBody?.length > 1) tableBody?.push(tBody);
      });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  const handleApply = () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    } 

    if (selection === SalesPerformanceList?.YEARLY) {
      if (
        year === null ||
        (year !== null && year?.getFullYear()?.toString() === "")
      ) {
        toast("Select year", ToastTypes?.ERROR);
        error = true;
      }
    }
  
       if (selection === SalesPerformanceList?.MONTHLY) {
        if (
          yearAndMonth === null ||
          (yearAndMonth !== null &&
            yearAndMonth?.getFullYear()?.toString() === "" &&
            yearAndMonth?.getMonth()?.toString() === "")
        ) {
          toast("Select month and year", ToastTypes?.ERROR);
          error = true;
        }
      }

      const yr = yearAndMonth?.getFullYear();
      const mon = month[yearAndMonth?.getMonth()];



    var getData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      // brand: brand,
      year: year?.getFullYear(),
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };

    var getMData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      // brand: brand,
      year: yr,
      month:mon,
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };

    if (
      error === false &&
      getData !== undefined &&
      getData?.limit !== "" &&
      getData?.offset !== ""
    ) {

      if(selection===SalesPerformanceList?.YEARLY){
      setloader(true);
      api
        .post<APIResponse<{ records: SalesRankingReportType[] }>>(
          `kpi/sales/salesRanking`,
          getData,
          config
        )
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setSalesRankingData(result);
            setloader(false);
          }
          else {
            setSalesRankingData([]);
            setloader(false);
          }
        })
        .catch((error) => {});
      }

      else if(selection===SalesPerformanceList?.MONTHLY){
        setloader(true);
        api
          .post<APIResponse<{ records: SalesRankingReportType[] }>>(
            `kpi/sales/salesRanking/monthly`,
            getMData,
            config
          )
          .then((response) => {
            if (response?.status === 200 && response?.data?.data) {
              const result = response?.data?.data?.records;
      
  
              setSalesRankingMonthlyData(result);
              setloader(false);
              if (authUser) {
                const logProps1 = {
                  action: "Apply",
                  event: `${pageName?.pathname?.replace(
                    "\\",
                    " "
                  )} page | Filters -  | Apply Clicked | Data Status:`,
                };
                UserLog(logProps1);
              }
            }
            else {
              setSalesRankingMonthlyData([])
              setloader(false);
            }
          })
          .catch((error) => {});
      }


    } 
  };





  useEffect(()=>{
    setLocation(selectedOption.location? selectedOption.location:'')
    const b = localityOption.filter((a)=>a?.area?.toString()===selectedOption.location?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.area,
        imgUrl:'', 
      };
      setLocationDrop([val]);
    }
    },[localityOption,selectedOption])

  useEffect(()=>{    
    if(selectedOption?.isOutletUser){
      setDisableLocality(true);
    
    }
    else{
      setDisableLocality(false);
    }
  },[authUser, outletList,selectedOption]);


  useEffect(() => {
    if (portfolios !== "" && fileLoader === false) {
      handleApply();
    } 
  }, [portfolios]);

  useEffect(() => {
    if (selection === SalesPerformanceList?.YEARLY && portfolios !== "")
      handleApply();
  }, [selection, portfolios]);
  useEffect(() => {
    if (selection === SalesPerformanceList?.MONTHLY && portfolios !== "")
      handleApply();
  }, [selection, portfolios]);

  const handleCsvDownload = async (from: string) => {
    setFileLoader(true);

    
    let Data = null
    if( selection===SalesPerformanceList?.MONTHLY){
      Data =
      from === "Top"
        ? salesRankingMonthlyData[0]?.topBrands
        : salesRankingMonthlyData[0]?.bottomBrands;
    }


    if( selection===SalesPerformanceList?.YEARLY){
    Data =
      from === "Top"
        ? salesRankingData[0]?.topBrands
        : salesRankingData[0]?.bottomBrands;
    }

    if (Data !== null && Data[0]?.record?.length !== 0 && Data[0]?.record?.length !== undefined) {
      const d = { ...getDownloadData(Data) };
      const filteredHead = d?.thead
        ?.map((a) => {
          const selectedRowsToMap =
            from === "Top" ? selectedRows : selectedRows1;

          const foundObject = selectedRowsToMap
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);

      const csvHead = filteredHead;
      const csvBody = d?.tbody;

      const head = [csvHead?.map((h) => h?.text || "") || []];
      const body =
        csvBody?.map((tr, i) => {
          return (
            csvHead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const rows = [...head, ...body];
      const props = {
        rows: rows,
        fileName: `Sales Ranking Report - ${from} 10 Brands`,
      };
      CSVdownload(props);
      setFileLoader(false);
    } else {
      setFileLoader(false);
    }
    setFileLoader(false);
  };

  const handlePdfDownload = async (from: string) => {
    setFileLoader(true);
    
    let Data = null
    if( selection===SalesPerformanceList?.MONTHLY){
      Data =
      from === "Top"
        ? salesRankingMonthlyData[0]?.topBrands
        : salesRankingMonthlyData[0]?.bottomBrands;
    }


    if( selection===SalesPerformanceList?.YEARLY){
    Data =
      from === "Top"
        ? salesRankingData[0]?.topBrands
        : salesRankingData[0]?.bottomBrands;
    }


    if (Data !== null && Data[0]?.record?.length !== 0 && Data[0]?.record?.length !== undefined) {
      const d = { ...getDownloadData(Data) };
      const filteredHead = d?.thead
        ?.map((a) => {
          const selectedRowsToMap =
            from === "Top" ? selectedRows : selectedRows1;

          const foundObject = selectedRowsToMap
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);

      const thead = filteredHead;
      const tbody = d?.tbody;

      const head = [thead?.map((h) => h?.text || "") || []];
      const body =
        tbody?.map((tr, i) => {
          return (
            thead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const props = {
        head: head,
        body: body,
        fileName: `Sales Ranking Report - ${from} 10 Brands`,
        title: `Sales Ranking Report - ${from} 10 Brands`,
      };
      handleDownloadPDF(props);
      setFileLoader(false);
    } else {
      setFileLoader(false);
    }
    setFileLoader(false);
  };

  const getTableData = (from: string) => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];
    let Data = null
    if( selection===SalesPerformanceList?.MONTHLY){
      Data =
      from === "Top"
        ? salesRankingMonthlyData[0]?.topBrands
        : salesRankingMonthlyData[0]?.bottomBrands;
    }
    if( selection===SalesPerformanceList?.YEARLY){
    Data =
      from === "Top"
        ? salesRankingData[0]?.topBrands
        : salesRankingData[0]?.bottomBrands;
    }

    Data?.forEach((y, i) => {
      const index = portfolioOption?.findIndex(
        (p) =>
          p?.id !== undefined && p?.id?.toString() === y?.portfolio?.toString()
      );

      const brandArray = y?.record?.map((r, j) => r?.brand)?.filter(getOnlyUnique);

      brandArray?.forEach((br, j) => {
        var tBody: Tbody[] = [];
        const brandIndex = filteredBrand?.findIndex(
          (c) => c?.id !== undefined && c?.id?.toString() === br?.toString()
        );
        const brandName = filteredBrand[brandIndex]?.name;
        const brandId = br;

        tBody?.push({
          id: "Brand" + brandId + j,
          theadId: "Brand",
          children: brandName,
          text: brandName,
        });
        y?.record
          ?.filter((r) => r?.brand?.toString() === brandId?.toString())
          ?.forEach((r, i) => {
            tBody?.push({
              id: r?.sales?.toString() + i,
              children: r?.sales,
              text: r?.sales,
              theadId: "NetSales",
            });
          });
        if (tBody?.length > 1) tableBody?.push(tBody);
      });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  useEffect(() => {
    const header = tHead
      ?.map((a) => a?.text)
      ?.filter((id): id is string => typeof id === "string" && id !== undefined);
    setSelectedRows(header);
  }, []);

  useEffect(() => {
    const header = tHead1
      ?.map((a) => a?.text)
      ?.filter((id): id is string => typeof id === "string" && id !== undefined);
    setSelectedRows1(header);
  }, []);

  const portfolio = useMemo<number[]>(() => {
    return portfolios !== "" ? [parseInt(portfolios)] : [];
  }, [portfolios]);

  const site = useMemo<string[]>(() => {
    if (authUserSiteId) {
      return authUserSiteId?.split(",")?.map((s) => {
        return s?.toString();
      });
    } else {
      return [];
    }
  }, [authUserSiteId]);

  const brand = useMemo<number[]>(() => {
    if (brands !== "") {
      return brands !== "" ? [parseInt(brands)] : [];
    } else return []; 
  }, [brands]);

  const company = useMemo<number[]>(() => {
    return companies !== "" ? [parseInt(companies)] : [];
  }, [companies]);

  const category = useMemo<number[]>(() => {
    return categories !== "" ? [parseInt(categories)] : [];
  }, [categories]);

  const subCategory = useMemo<number[]>(() => {
    return subCategories !== "" ? [parseInt(subCategories)] : [];
  }, [subCategories]);

  useEffect(()=>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
    }
},[portfolioOption,selectedOption])

  useEffect(() => {
    let sid = siteData[0] && siteData[0]?.id ? siteData[0]?.id?.toString() : "";
    setSites(selectedOption?.site ? selectedOption?.site : sid);
  }, [siteData, selectedOption]);

  // useEffect(() => {
  //   setCompanies(selectedOption?.company);
  // }, [selectedOption]);

  // useEffect(() => {
  //   if (selectedOption?.location) setLocation(selectedOption?.location);
  // }, [selectedOption]);

  useEffect(()=>{
    setCategories(selectedOption.category ? selectedOption.category:'');
    const b = categoryOption.filter((a)=>a?.id?.toString()===selectedOption.category?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl:'', 
      };
      setCatDrop([val]);
    }
    },[categoryOption,selectedOption])
    
    
    useEffect(()=>{
    setSubCategories(selectedOption.subCategory ? selectedOption.subCategory:'');
    const b = subCategoryOption.filter((a)=>a?.id?.toString()===selectedOption.subCategory?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl:'', 
      };
      setSubcatDrop([val]);
    }
    },[subCategoryOption,selectedOption])

  useEffect(() => {
    var range = [];
    var num = Math?.ceil(length / limit);
    for (let i = 1; i <= num; i++) {
      range?.push(i);
    }
    setRange(range);
  }, [length, limit]);

  useEffect(() => {
    if (sites !== ""&&selectedOption.isOutletUser===true) {
      let siteCurrencyObject = siteOption?.find(
        (s) => s?.id?.toString() === sites?.toString()
      );
      setValueIn(
        siteCurrencyObject?.currencycode +
          " | " +
          siteCurrencyObject?.valuecaption
      );
    } 
    else if(portfolios !== ""&&selectedOption.isOutletUser===false){
      let portfolioCurrencyObject = portfolioOption?.find(
        (s) => s?.id?.toString() === portfolios?.toString()
      );
      setValueIn(
        portfolioCurrencyObject?.reportingcurrency +
          " | " +
          portfolioCurrencyObject?.valuecaption
      );
    }
    else setValueIn("");
  }, [sites, siteOption,selectedOption]);

  useEffect(() => {
    if (salesRankingData?.length > 0&&selection===SalesPerformanceList?.YEARLY){
      setLength(
        salesRankingData[0]?.topBrands[0]?.count
          ? salesRankingData[0]?.topBrands[0]?.count
          : 0
      );
    }else if(salesRankingMonthlyData?.length > 0&&selection===SalesPerformanceList?.MONTHLY){
      setLength(
        salesRankingMonthlyData[0]?.topBrands[0]?.count
          ? salesRankingMonthlyData[0]?.topBrands[0]?.count
          : 0
      );
    }
  }, [salesRankingData,salesRankingMonthlyData,selection]);

  useEffect(() => {
    var getData = {
      portfolio: portfolio,
    };

    if (portfolio?.length > 0 && getData !== undefined) {
      api
        .post<
          APIResponse<{ records: CatSubCatCompanyWithBrandRelationDataType[] }>
        >(`filter/catSubcatCompanyRelationWithBrand`, getData, config)
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setCatSubCatCompanyWithBrandRelationData(result);
          }
        })
        .catch((error) => {});
    } else {
      setCatSubCatCompanyWithBrandRelationData([]);
    }
  }, [portfolio]);

  const getSubtitle = useMemo<string[]>(() => {
    let subtxt: string[] = [];
    let subtxt1 = `\u3010Company\u3011: ${pname}`;
    let subtxt2 = ``;
    if (location) {
      subtxt1 += `\u3010Locality\u3011: ${location}`;
    }
    // if (locations?.length > 0) {
    //   let locNameArr: string[] = [];
    //   locations?.map((s) => {
    //     locNameArr?.push(s?.label);
    //   });
    //   let localities = locNameArr?.join(", ");
    //   subtxt2 += ` \u3010Locality\u3011: ${localities}`;
    // }
    if (
      categories?.length > 0 &&
      categories !== undefined
    ) {
      const categoryIndex =
        categoryOption?.findIndex(
          (a) =>
            a?.id?.toString() ===
            categories?.toString()
        );
      const categoryName =
        categoryOption[categoryIndex]?.name;
      subtxt2 += ` \n\u3010TradeCategory\u3011: ${categoryName}`;
    }
    if (subCategories?.length > 0) {
      const subcategoryIndex =
        subCategoryOption?.findIndex(
          (a) =>
            a?.id?.toString() ===
            subCategories?.toString()
        );
      const subcatName =
        subCategoryOption[subcategoryIndex]?.name;
      subtxt2 += ` \u3010TradeSubcategory\u3011: ${subcatName}`;
    }
    subtxt1 += ` \u3010Year\u3011: ${year?.getFullYear()}`;
    subtxt?.push(subtxt1);
    subtxt?.push(subtxt2);
    return subtxt;
      
  }, [pname, sites, location, categories, subCategories, companies, localityOption, categoryOption, subCategoryOption, filteredBrandCompany]);


  const colors = [
    COLORS?.COLOR1,
    COLORS?.COLOR2,
    COLORS?.COLOR3,
    COLORS?.COLOR4,
    COLORS?.COLOR5,
    COLORS?.COLOR6,
    COLORS?.COLOR7,
    COLORS?.COLOR8,
  ];

  

  return (
    <UserLayout>
      <div className="card background-transparent p-1">
        <div className="row">
          <div
            className="col-lg-4 wow fadeInLeft ps-0"
          >
            <h4 className="b-title">Sales Ranking</h4>
          </div>

          <div className="col-lg-8 wow fadeInRight">
            <div className="row">
              <div className="col-sm-3 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Portfolio"
                  label=""
                  labelClassName="required"
                  value={portfolios}
                  onChange={handlePortfolioChange}
                  placeholder="Select"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select</option>
                  {portfolioData?.map((p, i) => {
                    return (
                      <Option value={p?.id} key={i}>
                        {p?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultPortfolio,
                    ...portfolioData?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: s?.logourl,
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={portfoliosOption}
                  setSelectedOptions={handlePortfolioChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}
                 <SingleSelect1
                      options={portfolioData.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={portfolioDrop}
                      setSelectedOptions={handlePortfolioDrop}
                      placeHolder="Select Portfolio"
                      onClear={handleClearPortfolio}
                      disabled = {disableLocality}
                    />
              </div>
              <div className="col-sm-3 col-md-4 col-lg-3">
              {/* <FormInput2
                  name="Location"
                  label=""
                  labelClassName="required"
                  value={location}
                  onChange={handleLocationChange}
                  placeholder="Select Locality"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Locality</option>
                  {localityOption?.map((s, i) => {
                    return (
                      <Option value={s?.area} key={i}>
                        {s?.area}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultLocation,
                    ...localityOption?.sort(function (a, b) {
                      if (a?.area < b?.area) {
                        return -1;
                      }
                      if (a?.area > b?.area) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.area,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={locationOption}
                  setSelectedOptions={handleLocationChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Location"
                  // filterText=""
                /> */}
              {/* <MultiSelect
                  options={localityOption?.map((sc) => {
                    return {
                      value: sc?.id ? sc?.id : 0,
                      label: sc?.area?.toString(),
                      imgUrl: "",
                    };
                  })}
                  label=""
                  selectedOptions={locations}
                  setSelectedOptions={setLocations}
                  placeHolder="All Locality"
                /> */}
                <SingleSelect1
                      options={localityOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.area?c?.area:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={locationDrop}
                      setSelectedOptions={handleLocationDrop}
                      placeHolder="Select Locality"
                      onClear={handleClearLocation}
                      disabled = {disableLocality}
                    />
              </div>
              <div className="col-sm-3 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Trade Category"
                  label=""
                  labelClassName="required"
                  value={categories}
                  onChange={handleCategoryChange}
                  placeholder="Select Trade Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Category</option>
                  {categoryOption?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                    {/* <SingleSelect
                  options={[
                    defaultTradeCategory,
                    ...categoryOption?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={categoriesOption}
                  setSelectedOptions={handleCategoryChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Trade Category"
                  // filterText=""
                /> */}
                <SingleSelect1
                      options={categoryOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={catDrop}
                      setSelectedOptions={handleCatDrop}
                      placeHolder="Select Trade Category"
                      onClear={handleClearCat}
                      disabled = {disableLocality}
                    />
              </div>
              <div className="col-sm-3 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Trade Sub Category"
                  label=""
                  labelClassName="required"
                  value={subCategories}
                  onChange={handleSubCategoryChange}
                  placeholder="Select Trade Sub Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Sub Category</option>
                  {subCategoryFilteredByCategory?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                  {/* <SingleSelect
                  options={[
                    defaultTradeSubCategory,
                    ...subCategoryFilteredByCategory?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={subCategoriesOption}
                  setSelectedOptions={handleSubCategoryChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Trade Sub Category"
                  // filterText=""
                /> */}
                   <SingleSelect1
                      options={subCategoryFilteredByCategory.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={subcatDrop}
                      setSelectedOptions={handleSubcatDrop}
                      placeHolder="Select Trade Sub Category"
                      onClear={handleClearSubcat}
                      disabled = {disableLocality}
                    />
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3 widget_div" onMouseEnter={() => setButtonVisible(true)} onMouseLeave={() => setButtonVisible(false)}>
                {(<button type="button" className="expandIconBtn" onClick={showExpandModalHandler} ><i><FontAwesomeIcon icon={faWindowMaximize} size="lg" title="Open in Popup"/></i></button>)}
                <div className="card-body" >
                <div className="row">
                    <div className="col-lg-6 col-sm-12 col-md-6">
                      <div className="float-start">
                        <h5 className="header-title">
                          <img src={chartIcon} alt="icon"></img>Sales Ranking
                        </h5>
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-end hstack gap-1">
                        {selection === SalesPerformanceList?.MONTHLY && (
                          <div
                            className="col-sm-6 col-md-6 col-lg-6"
                            style={{ width: "133px" }}
                          >
                            <div className="DateContainer">
                              <span className="dateInput">
                                <ReactDatePicker
                                  id="DatePicker"
                                  className="text-center fw-bold form-control"
                                  selected={yearAndMonth}
                                  onChange={(date: any) =>
                                    setYearAndMonth(date)
                                  }
                                  showMonthYearPicker
                                  dateFormat="MM/yyyy"
                                  yearItemNumber={8}
                                />
                              </span>
                              <span className="icon">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                    fill="#6C757D"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </div>
                        )}
                          
                        {selection===SalesPerformanceList?.YEARLY && (
                        <div className="col-sm-6 col-md-6 col-lg-6" style={{ width: "133px" }}>
                          <div className="DateContainer">
                            <span className="dateInput">
                              <DatePicker
                                id="DatePicker"
                                className="text-center fw-bold form-control"
                                selected={year}
                                onChange={(date: any) => setYear(date)}
                                showYearPicker
                                dateFormat="yyyy"
                                yearItemNumber={8}
                            />
                            </span>
                            <span className="icon">
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z" fill="#6C757D"></path></svg>
                            </span>
                          </div>
                        </div>
                        )}
                        
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleApply}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="m-0 my-2 p-0 hr" />
                  {salesRankingData?.[0]?.bottomBrands?.[0]?.record?.length !==
                    undefined &&
                    salesRankingData?.[0]?.bottomBrands?.[0]?.record?.length >
                      0 &&
                    salesRankingData?.[0]?.topBrands?.[0]?.record?.length !==
                      undefined &&
                    salesRankingData?.[0]?.topBrands?.[0]?.record?.length >
                      0 && <div>{"*Value in " + valueIn}</div>}

<><div className="col-lg-12 col-sm-12 text-end">                  
                    <button
                      type="button"
                      onClick={monthlyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "monthly"
                          ? "btn-primary"
                          : "btn-secondary"
                      }`}
                    >
                      Monthly
                    </button>

                    <button
                      type="button"
                      onClick={yearlyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "yearly" ? "btn-primary" : "btn-secondary"
                      }`}
                    >
                      Yearly
                    </button>
                  </div></>

                  {selection===SalesPerformanceList.YEARLY&&<div className="row">
                    {salesRankingData?.[0]?.bottomBrands?.[0]?.record
                      ?.length !== undefined ||
                    salesRankingData?.[0]?.bottomBrands?.[0]?.record?.length >
                      0 ||
                    salesRankingData?.[0]?.topBrands?.[0]?.record?.length !==
                      undefined ||
                    salesRankingData?.[0]?.topBrands?.[0]?.record?.length >
                      0 &&selection === SalesPerformanceList.YEARLY ? (
                      <>
                        <div className="col-6">
                          {salesRankingData[0]?.topBrands[0]?.record?.length !==
                            undefined &&
                          salesRankingData[0]?.topBrands[0]?.record?.length >
                            0 ? (
                            <SalesTop10Brands 
                              salesRankingData={salesRankingData} 
                              year={year} 
                              getSubtitle={getSubtitle}
                              filteredBrand={filteredBrand}
                            />
                          ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                              <p className="empty-data">No Records Found</p>
                            </div>
                          )}
                        </div>
                        <div className="col-6">
                          {salesRankingData[0]?.bottomBrands[0].record
                            ?.length !== undefined &&
                          salesRankingData[0]?.bottomBrands[0].record?.length >
                            0 ? (
                              <SalesBottom10Brands 
                                salesRankingData={salesRankingData} 
                                year={year} 
                                getSubtitle={getSubtitle}
                                filteredBrand={filteredBrand}
                              />
                          ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                              <p className="empty-data">No Records Found</p>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    )}
                  </div>}

                  {selection===SalesPerformanceList?.MONTHLY&&
                  (<div className="row">
                    {salesRankingMonthlyData?.[0]?.bottomBrands?.[0]?.record
                      ?.length !== undefined ||
                    salesRankingMonthlyData?.[0]?.bottomBrands?.[0]?.record?.length >
                      0 ||
                    salesRankingMonthlyData?.[0]?.topBrands?.[0]?.record?.length !==
                      undefined ||
                    salesRankingMonthlyData?.[0]?.topBrands?.[0]?.record?.length >
                      0 &&selection === SalesPerformanceList?.MONTHLY ? (
                      <>
                        <div className="col-6">
                          {salesRankingMonthlyData[0]?.topBrands[0]?.record?.length !==
                            undefined &&
                          salesRankingMonthlyData[0]?.topBrands[0]?.record?.length >
                            0 ? (
                              <SalesTop10BrandsMonthwise 
                              salesRankingMonthlyData={salesRankingMonthlyData}
                              yearAndMonth={yearAndMonth}
                              getSubtitle={getSubtitle}
                              filteredBrand={filteredBrand}
                              />
                          ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                              <p className="empty-data">No Records Found</p>
                            </div>
                          )}
                        </div>
                        <div className="col-6">
                          {salesRankingMonthlyData[0]?.bottomBrands[0]?.record
                            ?.length !== undefined &&
                          salesRankingMonthlyData[0]?.bottomBrands[0]?.record?.length >
                            0 ? (
                              <SalesBottom10BrandsMonthwise 
                                salesRankingMonthlyData={salesRankingMonthlyData}
                                yearAndMonth={yearAndMonth}
                                getSubtitle={getSubtitle}
                                filteredBrand={filteredBrand}
                            />
                          ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                              <p className="empty-data">No Records Found</p>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    )}
                  </div>)}



                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3">
                <div className="card-body">
                  <TransactionTable
                    data={[]}
                    {...getTableData("Top")}
                    title="Top 10 Brands Report"
                    downloadCSV={true}
                    downloadPDF={true}
                    fileName="Top 10 Brands Report"
                    onClickCSV={() => handleCsvDownload("Top")}
                    onClickPDF={() => handlePdfDownload("Top")}
                    range={range}
                    valueInString={valueIn}
                    fLoader={fileLoader}
                    onSelectedRowsChange={handleSelectedRowsChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3">
                <div className="card-body">
                  <TransactionTable1
                    data={[]}
                    {...getTableData("Bottom")}
                    title="Bottom 10 Brands Report"
                    downloadCSV={true}
                    downloadPDF={true}
                    fileName="Bottom 10 Brands Report"
                    onClickCSV={() => handleCsvDownload("Bottom")}
                    onClickPDF={() => handlePdfDownload("Bottom")}
                    range={range}
                    valueInString={valueIn}
                    fLoader={fileLoader}
                    onSelectedRowsChange1={handleSelectedRowsChange1}
                  />
                </div>
              </div>
            </div>
          </div>
         

          {showModal && selection===SalesPerformanceList?.YEARLY&&(
            <Modal
              headerText={"Sales Ranking"}
              visible={showModal}
              onClose={() => setShowModal(false)}
              size="xl"
              centered
              classname="widget-container-single"
            >
              <div className="card-body">
                <div className="row">
                  {salesRankingData?.[0]?.bottomBrands?.[0]?.record?.length !==
                    undefined &&
                  salesRankingData?.[0]?.bottomBrands?.[0]?.record?.length >
                    0 &&
                  salesRankingData?.[0]?.topBrands?.[0]?.record?.length !==
                    undefined &&
                  salesRankingData?.[0]?.topBrands?.[0]?.record?.length > 0 ? (
                    <>
                      <div className="col-6">
                        {salesRankingData[0]?.topBrands[0]?.record?.length !==
                          undefined &&
                        salesRankingData[0]?.topBrands[0]?.record?.length > 0 ? (
                          <SalesTop10Brands 
                              salesRankingData={salesRankingData} 
                              year={year} 
                              getSubtitle={getSubtitle}
                              filteredBrand={filteredBrand}
                          />
                        ) : (
                          <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                            <p className="empty-data">No Records Found</p>
                          </div>
                        )}
                      </div>
                      <div className="col-6">
                        {salesRankingData[0]?.bottomBrands[0]?.record?.length !==
                          undefined &&
                        salesRankingData[0]?.bottomBrands[0]?.record?.length >
                          0 ? (
                            <SalesBottom10Brands 
                              salesRankingData={salesRankingData} 
                              year={year} 
                              getSubtitle={getSubtitle}
                              filteredBrand={filteredBrand}
                            />
                        ) : (
                          <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                            <p className="empty-data">No Records Found</p>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                      <p className="empty-data">No Records Found</p>
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          )}

{showModal && selection===SalesPerformanceList?.MONTHLY&& (
            <Modal
              headerText={"Sales Ranking"}
              visible={showModal}
              onClose={() => setShowModal(false)}
              size="xl"
              centered
              classname="widget-container-single"
            >
              <div className="card-body">
              <div className="row">
                    {salesRankingMonthlyData?.[0]?.bottomBrands?.[0]?.record
                      ?.length !== undefined &&
                    salesRankingMonthlyData?.[0]?.bottomBrands?.[0]?.record?.length >
                      0 &&
                    salesRankingMonthlyData?.[0]?.topBrands?.[0]?.record?.length !==
                      undefined &&
                    salesRankingMonthlyData?.[0]?.topBrands?.[0]?.record?.length >
                      0 &&selection === SalesPerformanceList?.MONTHLY ? (
                      <>
                        <div className="col-6">
                          {salesRankingMonthlyData[0]?.topBrands[0]?.record?.length !==
                            undefined &&
                          salesRankingMonthlyData[0]?.topBrands[0]?.record?.length >
                            0 ? (
                              <SalesTop10BrandsMonthwise 
                                salesRankingMonthlyData={salesRankingMonthlyData}
                                yearAndMonth={yearAndMonth}
                                getSubtitle={getSubtitle}
                                filteredBrand={filteredBrand}
                              />
                          ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                              <p className="empty-data">No Records Found</p>
                            </div>
                          )}
                        </div>
                        <div className="col-6">
                          {salesRankingMonthlyData[0]?.bottomBrands[0]?.record
                            ?.length !== undefined &&
                          salesRankingMonthlyData[0]?.bottomBrands[0]?.record?.length >
                            0 ? (
                              <SalesBottom10BrandsMonthwise 
                                salesRankingMonthlyData={salesRankingMonthlyData}
                                yearAndMonth={yearAndMonth}
                                getSubtitle={getSubtitle}
                                filteredBrand={filteredBrand}
                              />
                          ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                              <p className="empty-data">No Records Found</p>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    )}
                  </div>
              </div>
            </Modal>
          )}



        </>
      )}
    </UserLayout>
  );
};
export default SalesRankingReport;
